import { AsyncPipe } from "@angular/common";
import { Component, Input, OnInit } from "@angular/core";
import { FormControl, ReactiveFormsModule } from "@angular/forms";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatOptionModule } from "@angular/material/core";
import { MatSelectModule } from "@angular/material/select";
import { map, Observable, startWith } from "rxjs";
import { DefaultComponent } from "src/app/default.component";
import { IconReplacePipe } from "src/pipes/icon-replace.pipe";
import { PrefixTemplate } from "../../PrefixTemplate";
import { PrefixValidator } from "../../PrefixValidator";
import { TemplateHTMLComponent } from "../template-html/template-html.component";
import { SelectGroup, SelectOption } from "../template-select/template-select.component";

@Component({
  selector: "app-template-search",
  imports: [MatSelectModule, MatOptionModule, TemplateHTMLComponent, ReactiveFormsModule, IconReplacePipe, MatAutocompleteModule, AsyncPipe],
  templateUrl: "./template-search.component.html",
  styleUrl: "./template-search.component.less",
})
export class TemplateSearchComponent extends DefaultComponent implements PrefixTemplate<string>, OnInit {
  @Input({ required: true })
  public control: FormControl<string | null> | null;

  @Input()
  public value: string | null;

  @Input()
  public label: string | null;

  @Input()
  public required: boolean;

  @Input()
  public disabled: boolean;

  @Input()
  public options: SelectOption[];

  @Input()
  public groups: SelectGroup[];

  @Input()
  public multiple: boolean;

  @Input()
  public selectFirstIfEmpty: boolean;

  public filteredOptions?: Observable<SelectOption[]>;
  public filteredGroups?: Observable<SelectGroup[]>;

  public constructor() {
    super();
    this.control = null;
    this.value = null;
    this.label = null;
    this.required = false;
    this.disabled = false;
    this.selectFirstIfEmpty = true;

    this.options = [];
    this.groups = [];
    this.multiple = false;
  }

  public ngOnInit(): void {
    const control = this.control;
    if (control) {
      this.addValidators(control);
      this.filteredOptions = control.valueChanges.pipe(
        startWith(control.value || ""),
        map((value) => this.filterOptions(value || "")),
      );
      this.filteredGroups = control.valueChanges.pipe(
        startWith(""),
        map((value) => this.filterGroups(value || "")),
      );
    } else {
      throw new Error("Undefined control");
    }
  }

  public displayLabel(): (value: string | null) => string {
    const options = this.options.slice();
    const groups = this.groups.slice();
    return (value: string | null): string => {
      let label = "";
      for (const option of options) {
        if (option.value === value) label = option.label;
      }
      for (const group of groups) {
        for (const option of group.options) {
          if (option.value === value) label = option.label;
        }
      }
      return label || value || "";
    };
  }

  private addValidators(control: FormControl<string | string[] | null>): void {
    if (this.required) control.addValidators([PrefixValidator.required()]);

    control.updateValueAndValidity();
  }

  private filterOptions(value: string, options: SelectOption[] = this.options): SelectOption[] {
    return options.filter((option) => option.label.toLowerCase().includes(value.toLowerCase()) || option.value === value);
  }

  private filterGroups(value: string, groups: SelectGroup[] = this.groups): SelectGroup[] {
    return groups
      .map((group) => {
        return { ...group, options: this.filterOptions(value, group.options) };
      })
      .filter((group) => group.options.length);
  }
}
